module.exports = require('./helpers/bundle-url').getBundleURL('2lNV8') + "declined.b9b71dfa.svg";